import '../../../scss/feature.scss';
import '../../../scss/critical.scss';
import '../../../scss/components/_hero.scss';

import 'bootstrap/js/dist/collapse';

import { ratingHelper } from '../../lib-sat/misc/rating-helper';
import { globalLogger } from '../../qaamgo/helper/global-logger';

import { initVueUploadBox } from '../../lib-sat/uploader/box/main';
import Vue from 'vue';
import ConversionPairSelector from '../../qaamgo/modules/sat/components/conversionpair/ConversionPairSelector.vue';
import AiFAQ from '../../qaamgo/modules/sat/components/ai/AiFAQ.vue';
import { translate } from '../../qaamgo/helper/translate';
import AiConversionOptions from '../../qaamgo/modules/sat/components/ai/AiConversionOptions.vue';
import AiStyleSwitcher from '../../qaamgo/modules/sat/components/ai/AiStyleSwitcher.vue';
import { userManager } from '../../lib-sat/user/user-manager';
import { satUserManager } from '../../lib-sat/user/sat-user';
import { registerPlaceholderToggle } from '../../lib-sat/misc/misc';

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(function () {
    import(
        /* webpackMode: "lazy" */
        '../../lib-sat/uploader/qg-uploader-functions'
    ).then(async function () {
        const user = await userManager.getUser();

        if (user.isRegistered) {
            import(
                /* webpackMode: "lazy" */
                '../../qaamgo/modules/sat/preset-selector'
            );
        }

        if (global.MODULE_LOADED_QG_FEATURE) {
            globalLogger.log('double import qg feature');

            return;
        }

        global.MODULE_LOADED_QG_FEATURE = true;

        window.qgRatingHelper = ratingHelper;
        qgRatingHelper.init(window.pageConfig.operation_rating);

        $(window).bind('beforeunload', function () {
            if (window.allowLeave === false) {
                return window.pageUploaderConfig.alertText;
            }
        });

        if (window.pageConfig.hasOwnProperty('operation')) {
            window.pageUploaderConfig.operation = window.pageConfig.operation;
        }

        if (window.pageConfig.hasOwnProperty('singleFile') && window.pageConfig.singleFile === true) {
            window.pageUploaderConfig.maxNumberOfInputs = 1;
            window.pageUploaderConfig.showFailedInput = false;
        }

        globalLogger.addLogData('operation', window.pageUploaderConfig.operation);

        // not sure if the uploader actually needs this
        if (window.pageUploaderConfig.operation !== 'unknown') {
            window.pageUploaderConfig.jobData = {
                operation: window.pageUploaderConfig.operation,
                fail_on_conversion_error: window.pageConfig.failOnConversionError,
                fail_on_input_error: window.pageConfig.failOnInputError,
            };
        }

        window.qgFeaturePage.init(window.pageUploaderConfig, window.pageConfig).then((uploader) => {
            window.qgUploader = uploader;

            import(
                /* webpackMode: "lazy-once" */
                `../translations/sat-translations.js`
            ).then(() => {
                initVueUploadBox();
            });

            registerPlaceholderToggle();
            qgFeaturePage.setupTargetDropDown(window.qgUploader);
            qgFeaturePage.highlightRadioButtons();

            var data = qgFeaturePage.getOptionsFromForm('#sendform');
            qgFeaturePage.showRelevantOptionsForTarget(data.category, data.target, window.qgUploader);

            qgFeaturePage.updateConversionOptionsForDropDown(window.qgUploader);

            var remoteUrl = window.qgFeaturePage.getValueFromCurrentUrl('remote_url');
            if (typeof remoteUrl === 'string') {
                window.qgUploader.addExternalUrl(remoteUrl);
            }

            var inputId = window.qgFeaturePage.getValueFromCurrentUrl('input_id');
            if (typeof inputId === 'string') {
                window.qgUploader.addInputId(inputId);
            }

            var externalUrl = window.qgFeaturePage.getValueFromCurrentUrl('external_url');
            if (typeof externalUrl === 'string') {
                window.qgUploader.addExternalUrl(externalUrl);
            }

            window.qgFeaturePage.addGdriveFilesFromQuery(window.qgUploader);
            window.qgFeaturePage.addJobFilesFromQuery(window.qgUploader);
            window.qgFeaturePage.addStorageFilesFromQuery(window.qgUploader);

            if ($('#scanMode').length) {
                function setConversionValues() {
                    if ($('#scanMode').is(':checked')) {
                        $('input[name ="target"]').val('png');
                        $('input[name ="category"]').val('image');

                        $('input[name ="width"]').val('1200');
                        $('input[name ="width"]').data('option-ignore', 'false');
                    } else {
                        $('input[name ="target"]').val('svg');
                        $('input[name ="category"]').val('image');

                        $('input[name ="width"]').val('');
                        $('input[name ="width"]').data('option-ignore', 'true');
                    }
                }
                setConversionValues();
                $('#scanMode').on('click', setConversionValues);
            }
        });
    });

    if (document.getElementsByClassName('colorize-image-wrapper').length > 0) {
        import('./colorize-image-comparison').then(() => { });
    }

    if (document.getElementsByClassName('ai-upscale-image-wrapper').length > 0) {
        import('./ai-upscale-image-comparison').then(() => { });
    }

    if (document.getElementsByClassName('ai-remove-background-wrapper').length > 0) {
        import('./ai-remove-background-comparison').then(() => { });
    }

    const conversionPairSelector = document.getElementById('conversionPairSelector');
    const pageType = document.getElementById('pageType');

    if (conversionPairSelector) {
        new Vue({
            el: '#conversionPairSelector',
            name: 'ConversionPairSelectorRoot',
            components: { ConversionPairSelector },
            render(h) {
                return h(ConversionPairSelector, { props: { pageType: pageType.dataset.pageType } });
            },
        });
    }

    $('[data-toggle=collapse]').click(function () {
        let $icon = $(this).find('i');
        let $collapseBox = $(this).parent().parent().parent().find('.collapse');
        if ($collapseBox.hasClass('show')) {
            $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        } else {
            $icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
        }
    });

    $('.collapse').on('hide.bs.collapse', function () {
        let $header = $(this).siblings('.card-header');
        let $icon = $header.find('i');
        $icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    });

    const aiConversionOptionSelector = document.getElementById('aiConversionOptionSelector');
    const optionsArray = [
        {
            name: translate('Realistic'),
            image: require(`../../../img/ai_images/realistic.jpg`),
            data_option: 'photorealistic',
        },
        {
            name: translate('Anime'),
            image: require(`../../../img/ai_images/anime.jpg`),
            data_option: 'anime',
        },
        {
            name: translate('Artistic'),
            image: require(`../../../img/ai_images/art.jpg`),
            data_option: 'artistic',
        },
        // {
        //     name: translate('Generic'),
        //     image: require(`../../../img/ai_images/generic/01.png`),
        //     data_option: 'generic',
        // },
    ];
    if (aiConversionOptionSelector) {
        new Vue({
            el: '#aiConversionOptionSelector',
            name: 'AiConversionOptions',
            components: { AiConversionOptions },
            render(h) {
                return h(AiConversionOptions, { props: { conversionOptions: optionsArray } });
            },
        });
    }

    const aiStyleSwitcherSelector = document.getElementById('aiStyleSwitcherSelector');

    const dataArray = [
        {
            name: 'Realistic',
            images: [
                require(`../../../img/ai_images/realistic/realistic_01.jpg`),
                require(`../../../img/ai_images/realistic/realistic_02.jpg`),
                require(`../../../img/ai_images/realistic/realistic_03.jpg`),
                require(`../../../img/ai_images/realistic/realistic_04.jpg`),
                require(`../../../img/ai_images/realistic/realistic_05.jpg`),
                require(`../../../img/ai_images/realistic/realistic_06.jpg`),
            ],
        },
        {
            name: 'Anime',
            images: [
                require(`../../../img/ai_images/anime/anime_01.jpg`),
                require(`../../../img/ai_images/anime/anime_02.jpg`),
                require(`../../../img/ai_images/anime/anime_03.jpg`),
                require(`../../../img/ai_images/anime/anime_04.jpg`),
                require(`../../../img/ai_images/anime/anime_05.jpg`),
                require(`../../../img/ai_images/anime/anime_06.jpg`),
            ],
        },
        {
            name: 'Artistic',
            images: [
                require(`../../../img/ai_images/artistic/art_01.jpg`),
                require(`../../../img/ai_images/artistic/art_02.jpg`),
                require(`../../../img/ai_images/artistic/art_03.jpg`),
                require(`../../../img/ai_images/artistic/art_04.jpg`),
                require(`../../../img/ai_images/artistic/art_05.jpg`),
                require(`../../../img/ai_images/artistic/art_06.jpg`),
            ],
        },
        // {
        //     name: 'Generic',
        //     images: [
        //         require(`../../../img/ai_images/generic/01.png`),
        //         require(`../../../img/ai_images/generic/02.png`),
        //         require(`../../../img/ai_images/generic/03.png`),
        //         require(`../../../img/ai_images/generic/04.png`),
        //         require(`../../../img/ai_images/generic/05.png`),
        //         require(`../../../img/ai_images/generic/06.png`),
        //     ],
        // },
    ];

    if (aiStyleSwitcherSelector) {
        new Vue({
            el: '#aiStyleSwitcherSelector',
            name: 'AiStyleSwitcher',
            components: { AiStyleSwitcher },
            render(h) {
                return h(AiStyleSwitcher, { props: { dataArray: dataArray } });
            },
        });
    }
});
